export const INVITE_TYPE_EMPLOYER_PROFILE_UPDATE = 'employerProfileUpdateWorkforceData';
export const INVITE_TYPE_EMPLOYER_AGREEMENT_SIGNER_MGMT = 'employerAgreementSignerManagement';
export const INVITE_TYPE_APPRENTICE_AGREEMENT_SIGNER_APPRENTICE = 'apprenticeAgreementSignerApprentice';
export const INVITE_TYPE_EMPLOYER_AGREEMENT_SIGNER_UNION = 'employerAgreementSignerUnion';
export const INVITE_TYPE_REGISTRATION = 'registration';

export const inviteTypeEnum = {
  [INVITE_TYPE_REGISTRATION]: 'Registration',
  [INVITE_TYPE_EMPLOYER_AGREEMENT_SIGNER_MGMT]: 'Employer Agreement: Employer Signature',
  // [INVITE_TYPE_EMPLOYER_AGREEMENT_SIGNER_UNION]: 'Employer Agreement: Union Signature',
  [INVITE_TYPE_APPRENTICE_AGREEMENT_SIGNER_APPRENTICE]: 'Apprentice Agreement: Apprentice Signature',
  [INVITE_TYPE_EMPLOYER_PROFILE_UPDATE]: 'Update Workforce Data'
};
